<template>
  <div v-show="visible" class="custom-dialog-mask">
    <div class="custom-dialog" :class="{ 'dialog-leave': !visible }">
      <div class="tipModal-index pt-[28px] px-[16px] pb-[20px]">
        <span class="text-sm text-textColor leading-[18px]">{{ title }}</span>
        <div class="dialog-body mt-[12px] text-sm text-[var(--no-role-tips-desc)] leading-[18px]">
          {{ content }}
        </div>
        <div class="flex justify-end">
          <div
            class="btn flex items-center justify-center mt-8 cursor-pointer"
            @click="handleClose"
          >
            我知道了
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{
  modelValue: boolean
  title: string
  content?: string
}>()

const emit = defineEmits<{
  // eslint-disable-next-line no-unused-vars
  (e: 'update:modelValue', value: boolean): void
  // eslint-disable-next-line no-unused-vars
  (e: 'close'): void
}>()

const visible = computed({
  get: () => props.modelValue,
  set: (val: boolean) => emit('update:modelValue', val)
})

// 和平服442 密码 85393359
// confirmRole, flushConfirm, placeCar,
const handleClose = () => {
  visible.value = false
  emit('close')
}
</script>

<style lang="less" scoped>
.custom-dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  padding: 0 20px;
  box-sizing: border-box;
  overflow: hidden;
}

.custom-dialog {
  position: relative;
  margin: 0 auto;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  transform: translateY(0);
  opacity: 1;
  background: var(--modal-bg-color);
  width: 80%;
  max-width: 395px;
}

.dialog-leave {
  transform: translateY(-20px);
  opacity: 0;
}

.tipModal-index {
  background-color: var(--verify-item-bg-color);
}

.btn {
  background: var(--primary-color);
  color: var(--btn-text-color);
  height: 36px;
  background: #BE3A34;
  border-radius: 20px 20px 20px 20px;
  width: 100%;
}

</style>
